export const defaultTimerOptions = {
    countdownSeconds: 300,
    playSoundCountdownComplete: true,
};

export interface TimerOptions {
    countdownSeconds: number;
    playSoundCountdownComplete: boolean;
}
